import { FC } from 'react';

import { EntityHistory } from '@work4all/components/lib/components/entity-preview/EntityHistory';
import { Divider } from '@work4all/components/lib/dataDisplay/divider/Divider';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

type IHistoryCardProps = {
  entity: Entities;
  id: string | number;
};

export const HistoryCard: FC<IHistoryCardProps> = ({ entity, id }) => (
  <>
    <Divider style={{ marginTop: '0.5rem' }} />
    <EntityHistory fitContainer={false} entity={entity} fullWidth id={id} />
  </>
);
